import { render, staticRenderFns } from "./ModalAddSection.vue?vue&type=template&id=512ec9c8&scoped=true"
import script from "./ModalAddSection.vue?vue&type=script&lang=js"
export * from "./ModalAddSection.vue?vue&type=script&lang=js"
import style0 from "./ModalAddSection.vue?vue&type=style&index=0&id=512ec9c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512ec9c8",
  null
  
)

export default component.exports